module.exports = __webpack_public_path__ + "static/amaurysechet-66dd4a242b7df64d961fc38803ca9d16.jpg";